// Vendor libraries
import { NgZone } from '@angular/core';
import * as i0 from "@angular/core";
/**
 * Dropdown Helper Service
 *
 * Calls a closeHandler function whenever a user clicks outside of the dropdown
 *
 */
export class DropdownHelperService {
    constructor(ngZone) {
        this.ngZone = ngZone;
    }
    setCloseHandler(dropdown, closeHandler) {
        /**
         * When a mousedown or touchstart event is initiated outside of `element`, call `closeHandler`
         *
         * @param dropdown - The HTML of the dropdown itself
         * @param closeHandler - The function to be called when clicking outside the dropdown
         */
        // Run event listeners outside of Angular zone so that they don't trigger unnecessary change detection cycles
        this.ngZone.runOutsideAngular(() => {
            ['mousedown', 'touchstart'].forEach((eventName) => {
                document.addEventListener(eventName, (e) => {
                    const targetEl = e.target;
                    const isOutsideDropdown = !dropdown.contains(targetEl);
                    const isPageScrollbar = targetEl.tagName === 'HTML';
                    if (isOutsideDropdown && !isPageScrollbar) {
                        this.ngZone.run(() => {
                            closeHandler(targetEl);
                        });
                    }
                }, { passive: true });
            });
        });
    }
}
DropdownHelperService.ɵfac = function DropdownHelperService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DropdownHelperService)(i0.ɵɵinject(i0.NgZone)); };
DropdownHelperService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DropdownHelperService, factory: DropdownHelperService.ɵfac, providedIn: 'root' });
